import { useCallback } from "react";
import { useDashboardContext } from "../contexts/dashboard-context";
import { useMessageToState } from "./useMessageToState";

/**
 * Returns information about QR support on the definition
 */
export function useQrSupport(
	page: eXpress.core.IPageZone | null | undefined,
	zone: eXpress.core.IZone | null | undefined,
) {
	const dashboard = useDashboardContext();

	// Recheck at each message
	return useMessageToState({
		name: "useQrSupport",
		getState: useCallback(
			function getQrSupport(editor) {
				const { definition } = editor;
				const isAddSupported = dashboard.canAddQrZoneToDefinition(definition);
				const isEditSupported = dashboard.canEditQrZoneOnDefinition(definition);
				const isDeleteSupported = dashboard.canDeleteQrZoneOnDefinition(definition);
				const isSupported = isAddSupported || isEditSupported || isDeleteSupported;

				const isAddEnabled = dashboard.canAddQrZoneToPage(page);
				const isEditEnabled = dashboard.canEditQrZone(zone);
				const isDeleteEnabled = dashboard.canDeleteQrZone(zone);
				const isEnabled = isAddEnabled || isEditEnabled || isDeleteEnabled;

				return {
					isAddSupported,
					isEditSupported,
					isDeleteSupported,
					isSupported,
					isAddEnabled,
					isEditEnabled,
					isDeleteEnabled,
					isEnabled,
				};
			},
			[dashboard, page, zone],
		),
	});
}
